import React from 'react';
import PropTypes from "prop-types";

const WorkItem = ({ portfolio }) => {
    return (
        <div className="single-portfolio" style={{textAlign: "center", width: "70%", margin: "auto"}}>
            <div className="thumbnail">
                <img className="img-fluid" src={portfolio.homeImage} alt="Portfolio-01" style={{borderRadius: "10px"}}/>
            </div>
            <div className="content">
                <h2 className="title" style={{fontSize: 25}}>{`${portfolio.title.slice(0, 22)}`} <img src={process.env.PUBLIC_URL + "/images/icons/arrow-up-right.svg"} alt=""/></h2>
            </div>
        </div>
    )
}

WorkItem.propTypes = {
    portfolio: PropTypes.object
};

export default WorkItem;
